<script setup>
import Calendar from "primevue/calendar";
import { ref } from "vue";
const value = ref("");
</script>

<template>
  <Calendar v-model="value" />
</template>
